import axios from "axios";
import { sessionLogout } from "./services/apiService";
import { identifyClarityUser } from "./Utils/clarity";

// Base URL configuration
// axios.defaults.baseURL = process.env.REACT_APP_BASE_API
//   ? `http://10.10.15.65:3002/v1`
//   : "";
axios.defaults.baseURL = process.env.REACT_APP_BASE_API
  ? `${process.env.REACT_APP_BASE_API}/v1`
  : "";

axios.defaults.headers.common["Content-Type"] = "application/json";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export function getSession(name) {
  const data = sessionStorage.getItem(name);
  return data ? data : null;
}

export function setSession(name, details) {
  sessionStorage.setItem(name, JSON.stringify(details));
}

// Response interceptor
axios.interceptors.response.use(
  async (response) => {
    // Save tokens on login/register/accountData
    if (response.data.data) {
      if (
        response.config.url.includes("login") ||
        response.config.url.includes("register") ||
        response.config.url.includes("accountData") ||
        response.config.url.includes("sso")
      ) {
        const refreshToken = response.data.data?.refreshToken;
        const accessToken =
          response.data.data?.authToken || response.data.data?.accessToken;
        const userId = JSON.stringify(response.data.data?.user);

        if (accessToken) sessionStorage.setItem("accessToken", accessToken);
        if (refreshToken) sessionStorage.setItem("refreshToken", refreshToken);
        if (userId) sessionStorage.setItem("userId", userId);
        identifyClarityUser(response.data.data?.user);
      }
    }

    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 409) {
      authRef.setIsOpenInvalidTokenModal(true);
      authRef.setIsOpenInvalidTokenModalMessage(
        error?.response?.data?.message || error?.response?.message
      );
    }

    if (
      error.response?.status !== 403 ||
      originalRequest._retry ||
      originalRequest.url.includes("login") ||
      originalRequest.url.includes("auth/2fa") ||
      originalRequest.url.includes("partnersso") ||
      originalRequest.url.includes("oauth/login") ||
      originalRequest.url.includes("socketAuth") ||
      originalRequest.url.includes("auth/logout")
    ) {
      return Promise.reject(error);
    }

    // Prevent retrying refresh-token request
    if (originalRequest.url.includes("refresh-token")) {
      authRef.setIsOpenInvalidTokenModal(true);
      return Promise.reject(error);
    }

    if (isRefreshing) {
      // Queue the request until token is refreshed
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers["Authorization"] = token;
          return axios(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    const refreshToken = getSession("refreshToken");

    if (!refreshToken) {
      isRefreshing = false;
      authRef.setIsOpenInvalidTokenModal(true);
      return sessionLogout();
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API}/v1/auth/refresh-token`,
        { refreshToken }
      );

      const newAccessToken = response.data.data?.accessToken;
      const newRefreshToken = response.data.data?.refreshToken;

      if (newAccessToken) {
        sessionStorage.setItem("accessToken", newAccessToken);
      }
      if (newRefreshToken) {
        sessionStorage.setItem("refreshToken", newRefreshToken);
      }

      processQueue(null, newAccessToken);

      originalRequest.headers["Authorization"] = newAccessToken;
      return axios(originalRequest);
    } catch (err) {
      authRef.setIsOpenInvalidTokenModal(true);
      processQueue(err, null);
      return sessionLogout();
    } finally {
      isRefreshing = false;
    }
  }
);

// Request interceptor for adding Authorization header
axios.interceptors.request.use(
  (request) => {
    // const token = JSON.parse(sessionStorage.getItem("token"));
    const token = getSession("accessToken");

    // Keep an Authorization header set explicitly by the caller (e.g. Bearer for logout)
    if (
      token &&
      !request.headers?.Authorization &&
      !request.url.includes("refresh-with-user")
    ) {
      request.headers["Authorization"] = token; // Add access token to request headers
    }
    return request;
  },
  (error) => {
    return Promise.reject(error); // Reject if request setup fails
  }
);
// axios.interceptors.request.use(
//   (request) => {
//     const token = getSession("accessToken");
//     if (token && !request.url.includes("refresh-with-user")) {
//       request.headers["Authorization"] = token;
//     }
//     return request;
//   },
//   (error) => Promise.reject(error)
// );

let authRef = {
  setIsOpenInvalidTokenModal: () => {},
};

export const setAuthRef = (methods) => {
  authRef = methods;
};
